import React from 'react'
import './HowToPlay.css'
import mobilemockup from '../../images/play-mobile-mockup.png'
import anna from '../../images/how-to-play-anna.png'

const HowToPlay = () => {
    return (

        <div className='how-to-play' id='howtoplay' >

            <div className='container'>

                <div className='how-to-play-content'>

                    <div className='how-to-play-heading' ><h2>HOW TO PLAY</h2></div>
                    <div className='how-to-play-sub-heading'><h4>Watch this video and learn How to Play Lata 777</h4></div>

                    <div className='how-to-play-img'>

                        <div className='how-to-play-anna' ><img src={anna} /></div>
                        <div className='how-to-play-mobile-mockup' ><img src={mobilemockup} /></div>

                    </div>

                </div>

            </div>

        </div>
    )
}

export default HowToPlay
